export enum MutationTypes {
    LOAD = 'LOAD',
    CHANGE_IS_TARGET_GROUPING = 'CHANGE_IS_TARGET_GROUPING',
    CHANGE_SORT_ORDER = 'CHANGE_SORT_ORDER',
    CHANGE_VISIBLE = 'CHANGE_VISIBLE',
    CHANGE_RUCRUIT_COST = 'CHANGE_RUCRUIT_COST',
}
